<!--
 * @Author: fengzhongmei
 * @Date: 2020-08-17 16:09:52
 * @LastEditors: fengzhongmei
 * @LastEditTime: 2020-08-17 16:51:42
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
-->
<template>
    <div class="building-container">
        <div class="container">
            <div class="bulid-img">
                <img class="cloud1"
                     src="@/assets/images/buildcloud1.png"
                     alt="">
                <img class="cloud2"
                     src="@/assets/images/buildcloud2.png"
                     alt="">
                <img src="@/assets/images/building.png"
                     alt="">
            </div>
            <p>功能开发中，敬请期待...</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'building'
}
</script>

<style lang="less" scoped>
.building-container {
    width: 100%;
    height: 100%;
    background-color: white;
    .container {
        margin: 0px auto;
        width: max-content;
        padding-top: 50%;
        transform: translateY(-50%);
        .bulid-img {
            position: relative;
            img:nth-last-child(1) {
                height: 170px;
            }
            .cloud1 {
                height: 30px;
                position: absolute;
                left: 0px;
                top: 50px;
                animation: cloudAnimation1 3s ease-in-out;
                animation-iteration-count: infinite;
            }
            .cloud2 {
                height: 40px;
                position: absolute;
                right: 0px;
                top: -20px;
                animation: cloudAnimation2 3s ease-in-out;
                animation-iteration-count: infinite;
            }
            @keyframes cloudAnimation1 {
                0% {
                    top: 50px;
                }
                50% {
                    top: 70px;
                }
                100% {
                    top: 50px;
                }
            }
            @keyframes cloudAnimation2 {
                0% {
                    right: 0px;
                }
                50% {
                    right: 20px;
                }
                100% {
                    right: 0px;
                }
            }
        }
        p {
            font-size: 16px;
            opacity: 0.6;
            color: #808080;
            text-align: center;
            margin-top: 15px;
        }
    }
}
</style>
